import { PostProperties } from "../types";
import image from "../img/lostGemReeko.jpg";

const post: PostProperties = {
  id: 17,
  title: "Reeko - The Home Of The Sounds, Salamanca, Spain (08.03.2008)",
  content: `Part of Selección Natural, Reeko is one of the most recognized faces coming from the Pole Group collective. Using different aliases and running his own label called "Mental Disorder", Reeko's carreer is nothing short of exceptional.`,
  image,
  buttonText: "Listen Here",
  buttonUrl:
    "https://soundcloud.com/shubinproject/reeko-the-home-of-the-sounds-salamanca-spain08032008",
  category: "Lost Gem",
  translationsBg: {
    content: `Като част от Selección Natural, Reeko е едно от най-разпознаваемите лица в колектива Pole Group. Използвайки различни псевдоними и ръководейки собствения си лейбъл "Mental Disorder", кариерата на Reeko е нищо по-малко от изключителна.`,
  },
};

export default post;
